import RefreshAuthStateCustomizer from './refresh-auth-state';
import PasswordResetAnetCustomizer from './password-expired/anet';
import PasswordResetNonAnetCustomizer from './password-expired/non-anet';
import PrimaryAuthCustomizer from './primary-auth';
import DirectOhswAdjacentAuthCustomizer from './primary-auth/direct-ohsw-adjacent-auth';
import BaseCustomizer from './base';
import CommonCustomizer from './common';
import GranularConsentCustomizer from './granular-consent';
import FactorEnrollCustomizer from './factors/enroll-factors';
import ChallengeFactorCustomizer from './factors/challenge-factors';
import TerminalCustomizer from './terminal';
import SuccessRedirect from './success-redirect';
import AmplitudeUtils from '../utils/amplitude-utils';
import EnrollPollQrCodeCustomizer from './okta-verify-enroll/enroll-poll/qrcode';
import EnrollPollSmsCustomizer from './okta-verify-enroll/enroll-poll/sms';
import SelectEnrollmentChannelCustomizer from './okta-verify-enroll/select-enrollment-channel';
import EnrollmentChannelDataCustomizer from './okta-verify-enroll/enrollment-channel-data';
import EnrollPhoneFactorCustomizer from './enroll-phone';
import ChallengeAuthenticatorCustomizer from './mfa-verify/challenge-authenticator';
import AuthenticatorVerificationDataCustomizer from './mfa-verify/authenticator-verification-data';
import { unhideWidget } from '../utils/widget-facade';
import EnrollAuthenticatorCustomizer from './authenticator-app-enroll/enroll-authenticator';
import MfaVerifyPasscodePhoneCustomizer from './mfa-verify/mfa-verify-passcode-phone';
import MfaVerifyPasscodeEmailCustomizer from './mfa-verify/mfa-verify-passcode-email';
import ChallengePollCustomizer from './mfa-verify/challenge-poll';
import EnrollQuestionCustomizer from './enroll-question';
import MfaVerifyQuestionCustomizer from './mfa-verify/mfa-verify-question';
import MfaVerifyWebAuthnCustomizer from './mfa-verify/mfa-verify-webauthn';
import { AppSettings } from '../utils/app-settings';
import EnrollPollMobileSameDeviceCustomizer from './okta-verify-enroll/enroll-poll/mobile-same-device';
import PasswordResetInitCustomizer from './password-reset/password-reset-init';
import PasswordResetCompletionCustomizer from './password-reset/password-reset-completion';
import EnrollWebAuthnCustomizer from './enroll-webauthn';


export interface CustomizeControllerArgs {
  requestContext: any;
  context: any;
  settings: AppSettings;
  config: any;
  oktaSignIn: any;
}

function getCustomizers(initArgs: CustomizeControllerArgs): Record<string, BaseCustomizer> {
  const commonCustomizer = new CommonCustomizer(initArgs);
  const primaryAuthCustomizer = new PrimaryAuthCustomizer(initArgs);
  const directOhswAdjacentAuthCustomizer = new DirectOhswAdjacentAuthCustomizer(initArgs);
  const granularConsentCustomizer = new GranularConsentCustomizer(initArgs);
  const passwordResetAnetCustomizer = new PasswordResetAnetCustomizer(initArgs);
  const passwordResetNonAnetCustomizer = new PasswordResetNonAnetCustomizer(initArgs);
  const factorEnrollCustomizer = new FactorEnrollCustomizer(initArgs);
  const terminalCustomizer = new TerminalCustomizer(initArgs);
  const challengeFactorCustomizer = new ChallengeFactorCustomizer(initArgs);
  const refreshAuthStateCustomizer = new RefreshAuthStateCustomizer(initArgs);
  const enrollPollQrCodeCustomizer = new EnrollPollQrCodeCustomizer(initArgs);
  const enrollPollSmsCustomizer = new EnrollPollSmsCustomizer(initArgs);
  const enrollPollMobileSameDeviceCustomizer = new EnrollPollMobileSameDeviceCustomizer(initArgs);
  const selectEnrollmentChannelCustomizer = new SelectEnrollmentChannelCustomizer(initArgs);
  const enrollmentChannelDataCustomizer = new EnrollmentChannelDataCustomizer(initArgs);
  const enrollPhoneFactorCustomizer = new EnrollPhoneFactorCustomizer(initArgs);
  const enrollAuthenticatorCustomizer = new EnrollAuthenticatorCustomizer(initArgs);
  const challengeAuthenticatorCustomizer = new ChallengeAuthenticatorCustomizer(initArgs);
  const challengePollCustomizer = new ChallengePollCustomizer(initArgs);
  const mfaVerifyPasscodePhoneCustomizer = new MfaVerifyPasscodePhoneCustomizer(initArgs);
  const authenticatorVerificationDataCustomizer = new AuthenticatorVerificationDataCustomizer(initArgs);
  const mfaVerifyPasscodeEmailCustomizer = new MfaVerifyPasscodeEmailCustomizer(initArgs);
  const successRedirect = new SuccessRedirect(initArgs);
  const enrollQuestionCustomizer = new EnrollQuestionCustomizer(initArgs);
  const mfaVerifyQuestionCustomizer = new MfaVerifyQuestionCustomizer(initArgs);
  const mfaVerifyWebAuthnCustomizer = new MfaVerifyWebAuthnCustomizer(initArgs);
  const passwordResetInitCustomizer = new PasswordResetInitCustomizer(initArgs);
  const passwordResetCompletionCustomizer = new PasswordResetCompletionCustomizer(initArgs);
  const enrollWebAuthnCustomizer = new EnrollWebAuthnCustomizer(initArgs);
  return {
    commonCustomizer,
    refreshAuthStateCustomizer,
    primaryAuthCustomizer,
    directOhswAdjacentAuthCustomizer,
    granularConsentCustomizer,
    passwordResetAnetCustomizer,
    passwordResetNonAnetCustomizer,
    factorEnrollCustomizer,
    challengeFactorCustomizer,
    terminalCustomizer,
    successRedirect,
    enrollPollQrCodeCustomizer,
    enrollPollSmsCustomizer,
    enrollPollMobileSameDeviceCustomizer,
    selectEnrollmentChannelCustomizer,
    enrollmentChannelDataCustomizer,
    enrollPhoneFactorCustomizer,
    enrollAuthenticatorCustomizer,
    challengeAuthenticatorCustomizer,
    challengePollCustomizer,
    mfaVerifyPasscodePhoneCustomizer,
    authenticatorVerificationDataCustomizer,
    mfaVerifyPasscodeEmailCustomizer,
    enrollQuestionCustomizer,
    mfaVerifyQuestionCustomizer,
    mfaVerifyWebAuthnCustomizer,
    passwordResetInitCustomizer,
    passwordResetCompletionCustomizer,
    enrollWebAuthnCustomizer,
  };
}

export default async function customizeController(initArgs: CustomizeControllerArgs) {
  const customizers = getCustomizers(initArgs);

  for (const customizerName in customizers) {
    const customizer = customizers[customizerName];
    try {
      await customizer.performCustomization();
    }
    catch (e: any) {
      AmplitudeUtils.logCustomizerError({
        customizerName,
        stackTrace: e.stack,
        errorMessage: e.message,
        errorName: e.name,
        ...initArgs.context,
      });
    }
  }
  // widget got hidden with the custom logic added on render function
  unhideWidget();
}
